export const CARGAR_NOTARIA = 'CARGAR_NOTARIA';